import { render, staticRenderFns } from "./first-run.vue?vue&type=template&id=6772e746&"
import script from "./first-run.vue?vue&type=script&lang=js&"
export * from "./first-run.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports